import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { TestSpec } from '@src/types/graphql-types'
import messages from '@utils/messages'

const useStyles = makeStyles((theme: Theme) => ({
  headingGrid: {
    paddingRight: '30px',
    alignSelf: 'center',
    width: '100%',
    marginBottom: 5,
  },
  heading: {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.grey[900],
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.1px',
  },
  subheading: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    margin: '5px 0 15px 0',
    fontSize: theme.typography.pxToRem(12),
  },
  revision: {
    display: 'inline',
    alignSelf: 'center',
    textAlign: 'right',
  },
  logoContainer: {
    alignSelf: 'flex-end',
  },
  logo: {
    float: 'right',
    height: '1rem',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
  },
}))

interface RevisionData {
  revno: string
  date: string
}

interface CertificateHeaderProps {
  coa?: boolean
  testSpecs: TestSpec[] | null | undefined
  revisionData: RevisionData
}

const CertificateHeader: React.FC<CertificateHeaderProps> = ({
  coa,
  testSpecs,
  revisionData,
}) => {
  const revisionNoSpec =
    testSpecs &&
    testSpecs.find((testSpec) => testSpec.name === revisionData.revno)
  const revisionNo = revisionNoSpec ? revisionNoSpec.value : null
  const revisionDateSpec =
    testSpecs &&
    testSpecs.find((testSpec) => testSpec.name === revisionData.date)
  const revisionDate = revisionDateSpec ? revisionDateSpec.value : null
  const classes = useStyles()
  return (
    <Grid container>
      <Grid item xs={6} md={6} className={classes.headingGrid}>
        <h1 className={classes.heading}>
          {coa ? (
            <FormattedMessage
              id="CERTIFICATE_OF_ANALYSIS"
              defaultMessage="Certificate of Analysis"
            />
          ) : (
            <FormattedMessage {...messages.CERTIFICATE_OF_ORIGIN} />
          )}
        </h1>
        {/* Adding Grid changes */}
      </Grid>
      <Grid item xs={6} md={6} className={classes.revision}>
        {revisionNo && revisionDate && (
          <span>
            <FormattedMessage {...messages.REVISION_NUMBER} />
            {'  '}
            <span>{revisionNo}</span>,{'  '}
            <FormattedMessage {...messages.EFFECTIVE} />
            {'  '}
            <span>{revisionDate}</span>
          </span>
        )}
      </Grid>
    </Grid>
  )
}

export default CertificateHeader
